<template>
  <div>
    <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: `StatisticsBySiteChart`,

  props: {
    interventions: Array,
    sites: Array,
  },

  data: () => ({
  }),

  computed: {
    bySiteInterventions() {
      const bySiteInterventions = {};

      this.interventions.forEach(intervention => {
        const site = _.find(this.sites, { id: intervention.Site_id });
        if (!site) { return; }
        if (!bySiteInterventions[site.id]) {
          bySiteInterventions[site.id] = [];
        }
        bySiteInterventions[site.id].push({
          ...intervention,
          site,
        });
      });

      return bySiteInterventions;
    },
    bySiteSerie() {
      const bySiteSerie = this.sites.map(site => ({
        ...site,
        count: (this.bySiteInterventions[site.id] || []).length,
      }));

      return _.chain(bySiteSerie)
        .filter(site => site.count > 0)
        .orderBy(`count`, `desc`)
        .slice(0, 5)
        .value();
    },

    series() {
      return [{
        name: `Interventions`,
        data: _.map(this.bySiteSerie, `count`),
      }];
    },
    chartOptions() {
      return {
        chart: {
          type: `bar`,
          toolbar: {
            show: false,
          },
        },
        title: {
          text: `Top 5 sites`,
        },
        colors: [`#008ffb`],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        legend: {
          show: false,
        },
        labels: _.map(this.bySiteSerie, `name`),
      };
    },
  },
};
</script>

<style lang="scss">
</style>
